import { css } from '@emotion/react';
import { i18next } from '@frontend/i18n';
import { TooltipContentProps } from '@frontend/product-onboarding';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { CALL_INTEL_BASE_ONBOARDING_HOTSPOT_KEYS } from '../constant';

interface HotspotHintConfig {
  title: string;
  description: string;
}

const hotspotHintMap: Record<string, HotspotHintConfig> = {
  [CALL_INTEL_BASE_ONBOARDING_HOTSPOT_KEYS.CALL_INSIGHT_PANEL_TRANSCRIPT_TAB]: {
    title: i18next.t('Skip the recording. Never take notes again.', { ns: 'call-intel-onboarding' }),
    description: i18next.t('Call Intelligence automatically summarizes and transcribes every eligible call.', {
      ns: 'call-intel-onboarding',
    }),
  },
  [CALL_INTEL_BASE_ONBOARDING_HOTSPOT_KEYS.PATIENT_PROFILE_LAST_CALL_CARD]: {
    title: i18next.t('Be prepared for your next conversation.', { ns: 'call-intel-onboarding' }),
    description: i18next.t('Quickly see what was discussed in the last call summary.', {
      ns: 'call-intel-onboarding',
    }),
  },
  [CALL_INTEL_BASE_ONBOARDING_HOTSPOT_KEYS.PATIENT_PROFILE_HISTORY_TAB_CALL]: {
    title: i18next.t('Access summaries and transcripts from past conversations.', { ns: 'call-intel-onboarding' }),
    description: i18next.t('Click into any past call to see its summary and transcript.', {
      ns: 'call-intel-onboarding',
    }),
  },
  [CALL_INTEL_BASE_ONBOARDING_HOTSPOT_KEYS.ORGANIZATION_SETTINGS_USER_TABLE_ACTION_BUTTON]: {
    title: i18next.t('Make your team even more effective.', { ns: 'call-intel-onboarding' }),
    description: i18next.t('Share Call Intelligence with your team by assigning the Data Analyst role.', {
      ns: 'call-intel-onboarding',
    }),
  },
};

export function HotspotTooltipContent({ hotspotId }: TooltipContentProps) {
  const config = hotspotHintMap[hotspotId];
  if (!config) return null;
  return (
    <div>
      <Text size='medium' weight='bold' css={styles.title}>
        {config.title}
      </Text>
      <Text size='small' weight='regular'>
        {config.description}
      </Text>
    </div>
  );
}

const styles = {
  title: css`
    white-space: wrap;
    margin-bottom: ${theme.spacing(1)};
  `,
};
